<div class="collection-view">
@if(collection) {
    <div class="row">
        <div class="col-12 col-md-3 col-xxl-2">
            <aside>
                <div class="side-panel">
                    <h4>{{ 'collection.description'|translate }}</h4>
                    {{ collection.description }}
                </div>
                <div class="side-panel">
                    <dl>
                        @if (collection.createdAt) {
                            <dt>{{ 'collection.createddate'|translate }}:</dt>
                            <dd>{{ collection.createdAt | dateLocale }}</dd>
                        }
                        <dt>{{ 'collection.modifieddate'|translate }}:</dt>
                        <dd>{{ collection.updatedAt | dateLocale }}</dd>
                        @if(collection.createdBy && user) {
                            <dt>{{'collection.owner'| translate}}:</dt>
                            <dd class="has-button">{{ collection?.createdBy?.fullName }}</dd>
                        }
                    </dl>
                </div>
            </aside>
        </div>
        <div class="col-12 col-md-9 col-xxl-10">
            <div class="row">
                <div class="col-12">
                    <header>
                        <h1>{{ collection.name }}</h1>
                       <!--@if (collection.uuid && user) {
                            <button mat-icon-button matSuffix (click)="edit()">
                                <mat-icon fontIcon="edit"></mat-icon>
                            </button>
                        } -->
                    </header>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <section id="collection-content">
                        <app-asset-result [assets]="assets"
                                          [totalItems]="totalAssets"
                                          [renderStyle]="AssetRenderStyle.tile">
                        </app-asset-result>
                    </section>
                </div>
            </div>
        </div>
    </div>
}
    @if(collectionError) {
        <div class="row justify-content-center">
            <div class="col-12 col-sm-8 col-md-6 col-lg-4 col-xl-4 col-xxl-3">
                <div class="error-box">
                    <div class="error-wrapper">
                        <div class="icon-wrapper"><mat-icon fontIcon="cancel"></mat-icon></div>
                        <div class="mt-3"><h1>{{'collection.unavailable' | translate}}</h1></div>
                    </div>
                </div>
            </div>
        </div>
    }

</div>
